/**
 * Business ERP route-level enter transition — CSS + motion tokens (Stream D5)
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import './business-route-transition.css';

export interface BusinessRouteTransitionProps {
  children: React.ReactNode;
}

export const BusinessRouteTransition: React.FC<BusinessRouteTransitionProps> = ({ children }) => {
  const location = useLocation();
  const shouldDisableRemountKey = true;

  return (
    <div
      {...(!shouldDisableRemountKey ? { key: location.pathname } : {})}
      className="business-route-enter"
    >
      {children}
    </div>
  );
};

export default BusinessRouteTransition;
